import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../Redux";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import MultiRangeSlider from "../../Components/MultiRangeSlider";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";

const Payables = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const financePayablesOutstanding = useSelector(
    (state) => state?.financeReducer?.financePayablesOutstanding
  );
  useEffect(() => {
    dispatch(actions?.getFinancePayablesOutstanding());
  }, []);
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div class="row mx-0"></div>
              </div>
            </div>
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine3"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#accountsPaybles"
                    aria-expanded="true"
                    aria-controls="accountsPaybles"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">Accounts Payable</h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="accountsPaybles"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine3"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    <th>Sub-Account Name</th>
                                    <th>Payee Name</th>
                                    <th>Outstanding Balance</th>
                                    <th>30-Day Aged Balance</th>
                                    <th>60-Day Aged Balance</th>
                                    <th>90-Day+ Aged Balance</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {financePayablesOutstanding?.accountsL01?.map(
                                    (el, idx) => (
                                      <tr>
                                        <td>{el?.name}</td>
                                        <td>{el?.payee_name}</td>
                                        <td>{el?.current_balance}</td>

                                        <td>{el?.["30days"]}</td>
                                        <td>{el?.["60days"]}</td>
                                        <td>{el?.["90days"]}</td>

                                        <td>
                                          {el?.current_balance > 0 ? (
                                            <a class="confirmProd btn green-btn-revert">
                                              Payment
                                            </a>
                                          ) : (
                                            <a class="confirmProd btn black_btn bordered'">
                                              Payment
                                            </a>
                                          )}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine3"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#longtermDebts"
                    aria-expanded="true"
                    aria-controls="longtermDebts"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">Long Term Debts</h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="longtermDebts"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine3"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    <th>Liability Name</th>
                                    <th>Payee Name</th>
                                    <th>Outstanding Amount</th>
                                    <th>Total Payments </th>
                                    <th>Interest Accrued</th>
                                    <th>Initial Principle Amount</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {financePayablesOutstanding?.accountsL04?.map(
                                    (el, idx) => (
                                      <tr>
                                        <td>{el?.name}</td>
                                        <td>{el?.payee_name}</td>
                                        <td>{el?.current_balance}</td>

                                        <td>{el?.["30days"]}</td>
                                        <td>{el?.["60days"]}</td>
                                        <td>{el?.["90days"]}</td>

                                        <td>
                                          {el?.current_balance > 0 ? (
                                            <a class="confirmProd btn green-btn-revert">
                                              Payment
                                            </a>
                                          ) : (
                                            <a class="confirmProd btn black_btn bordered'">
                                              Payment
                                            </a>
                                          )}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine3"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#shorttermDebts"
                    aria-expanded="true"
                    aria-controls="shorttermDebts"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">
                        Other Short Term Debts
                      </h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="shorttermDebts"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine3"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    <th>Liability Name</th>
                                    <th>Payee Name</th>
                                    <th>Outstanding Amount</th>
                                    <th>Total Payments </th>
                                    <th>Interest Accrued</th>
                                    <th>Initial Principle Amount</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {financePayablesOutstanding?.accountsL05?.map(
                                    (el, idx) => (
                                      <tr>
                                        <td>{el?.name}</td>
                                        <td>{el?.payee_name}</td>
                                        <td>{el?.current_balance}</td>

                                        <td>{el?.["30days"]}</td>
                                        <td>{el?.["60days"]}</td>
                                        <td>{el?.["90days"]}</td>

                                        <td>
                                          {el?.current_balance > 0 ? (
                                            <a class="confirmProd btn green-btn-revert">
                                              Payment
                                            </a>
                                          ) : (
                                            <a class="confirmProd btn black_btn bordered'">
                                              Payment
                                            </a>
                                          )}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Payables;
